import monteNidoLogo from "../../../src/assets/images/MonteNido_Logo.png";

// import landingImage from 'assets/images/landingImage.png'

const UIConfig = {
  branding: {
    logo: monteNidoLogo,
    appName: "MonteNido",
    timeZone: "America/New_York",
  },
  landing: {
    backgroundImage: "assets/images/MonteNidoLanding.png",
    title: 'Eating Disorder Solution',
    subTitle: 'Deep Insights. Compassionate Care. Smarter Decisions.',
    text: 'Drive admissions with confidence. Shorten wait times for families. Support recovery every step of the way.Together,let\'s expand access and accelerate recovery',
    footer: 'Turn conversations into actionable insights',
    operationHomeBtnText: 'Admission Insights',
    agentBtnText: 'Agent\'s Guide',
    dashboardBtnText: 'Executive Dashboard',
    performanceBtnText: 'Performance Dashboard'
  },
  operationHome: {
    agentImprovementText:
   " Agents are sometimes missing opportunities to fully address objections, secure clear next steps, and gather complete clinical and insurance information. Strengthening structured call leadership, risk identification, and follow-up clarity will improve conversion consistency and overall patient experience."},
  detailPanel: {
    Heading: "Eating Disorder Solution",
    Text: "Unlock insights, track performance, and enhance customer interactions with our AI-driven tools.",
  },
};

export default UIConfig;
